// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w574ZqC9IizqW6sOeW6A {
  height: var(--size);
  width: var(--size);
  min-width: var(--size);
  min-height: var(--size);
  border: var(--border-size) solid var(--color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/icons/ChevronInACircle/ChevronInACircle.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".circle {\n  height: var(--size);\n  width: var(--size);\n  min-width: var(--size);\n  min-height: var(--size);\n  border: var(--border-size) solid var(--color);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `w574ZqC9IizqW6sOeW6A`
};
export default ___CSS_LOADER_EXPORT___;
